
'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Users, Target, Rocket, Award, CheckCircle2 } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Mini Header / Botão Voltar */}
      <div className="border-b px-4 py-3 bg-muted/20">
        <Button asChild variant="ghost" size="sm" className="h-8 text-xs font-bold uppercase">
          <Link href="/">
            <ArrowLeft className="mr-2 h-4 w-4" /> 
            Voltar ao Catálogo
          </Link>
        </Button>
      </div>

      <main className="container mx-auto max-w-4xl px-4 py-12">
        <div className="space-y-12">
          {/* Título Principal */}
          <div className="border-b-4 border-primary pb-4 font-bold">
            <h1 className="text-3xl uppercase tracking-tighter">Quem Somos</h1>
            <p className="text-muted-foreground uppercase text-[10px] mt-1 tracking-widest">Peça na Medida | Catálogo Técnico Digital</p>
          </div>

          {/* Texto de Introdução */}
          <section className="space-y-6">
            <p className="text-base leading-relaxed text-foreground">
              O <strong>Peça na Medida</strong> é uma ferramenta profissional desenvolvida para agilizar o cotidiano de oficinas mecânicas e balcões de autopeças. 
              Nossa plataforma foca na precisão absoluta, permitindo que componentes sejam identificados por suas medidas técnicas reais, eliminando o erro humano e reduzindo devoluções.
            </p>
          </section>

          {/* Grid de Propósitos */}
          <div className="grid gap-4 sm:grid-cols-3">
             <div className="border p-4 bg-muted/5">
                <Target className="h-7 w-7 text-primary mb-3" />
                <h3 className="font-bold uppercase text-[11px] mb-1">Missão</h3>
                <p className="text-[11px] text-muted-foreground leading-snug">Precisão técnica na busca de peças através de filtros milimétricos.</p>
             </div>
             <div className="border p-4 bg-muted/5">
                <Rocket className="h-7 w-7 text-primary mb-3" />
                <h3 className="font-bold uppercase text-[11px] mb-1">Foco</h3>
                <p className="text-[11px] text-muted-foreground leading-snug">Ferramenta leve e rápida para computadores comuns de balcão.</p>
             </div>
             <div className="border p-4 bg-muted/5">
                <Award className="h-7 w-7 text-primary mb-3" />
                <h3 className="font-bold uppercase text-[11px] mb-1">Qualidade</h3>
                <p className="text-[11px] text-muted-foreground leading-snug">Dados confiáveis baseados em especificações de mercado.</p>
             </div>
          </div>

          {/* Diferenciais Técnicos */}
          <section className="border p-6 space-y-6">
            <h2 className="text-sm font-bold uppercase tracking-widest text-primary italic">Diferenciais do Sistema</h2>
            <div className="grid gap-4">
               {[
                 { title: "Alta Performance", desc: "Desenvolvido para carregar instantaneamente, mesmo em conexões limitadas." },
                 { title: "Busca Técnica", desc: "Filtros avançados por medidas de diâmetro, comprimento e filetes." },
                 { title: "Usabilidade", desc: "Design focado na produtividade do mecânico e do vendedor." }
               ].map((item, i) => (
                 <div key={i} className="flex gap-3 items-start border-b border-muted pb-3 last:border-0">
                    <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                    <div>
                       <h4 className="font-bold text-[11px] uppercase">{item.title}</h4>
                       <p className="text-[11px] text-muted-foreground">{item.desc}</p>
                    </div>
                 </div>
               ))}
            </div>
          </section>
        </div>
      </main>

      <footer className="mt-auto border-t p-6 text-center bg-muted/20">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-[9px] font-bold uppercase text-muted-foreground tracking-tighter">
           <span>Peça na Medida v1.0.0</span>
           <div className="flex gap-4">
             <Link href="/privacy" className="hover:text-primary">Privacidade</Link>
             <Link href="/support" className="hover:text-primary">Suporte</Link>
           </div>
        </div>
      </footer>
    </div>
  );
}
